import { render, staticRenderFns } from "./material-input.vue?vue&type=template&id=d49507e2&scoped=true"
import script from "./material-input.vue?vue&type=script&lang=js"
export * from "./material-input.vue?vue&type=script&lang=js"
import style0 from "./material-input.vue?vue&type=style&index=0&id=d49507e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49507e2",
  null
  
)

export default component.exports